import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST

export const LIST_TENANT_PROPERTY = `${LOCAL_URL}/tenant/listTenantProperty`
export const TENANT_RENT_PAYMENT_LIST = `${LOCAL_URL}/tenant/tenantRentPaymentList`

// function to fetch tenant properties
export async function getTenantProperties(offset:number, limit:number) {
  return await axios.post(LIST_TENANT_PROPERTY, {offset, limit})
}

// function to fetch the tenant rent list
export async function getTenantRentPaymentList(
  property_uuid: string,
  offset: number,
  limit: number
) {
  return await axios.post(TENANT_RENT_PAYMENT_LIST, {property_uuid, offset, limit})
}
